import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input"];

  connect() {
    console.log("Form reset controller connected");
    // Auto-resize textarea on connect if it's a textarea
    if (this.hasInputTarget && this.inputTarget.tagName === "TEXTAREA") {
      this.autoResize();
    }
  }

  autoResize() {
    if (this.hasInputTarget && this.inputTarget.tagName === "TEXTAREA") {
      const textarea = this.inputTarget;
      // Reset height to auto to get the correct scrollHeight
      textarea.style.height = "auto";
      // Set height to scrollHeight (content height)
      const newHeight = Math.min(textarea.scrollHeight, 200); // Max 200px
      textarea.style.height = `${newHeight}px`;
    }
  }

  reset(event) {
    if (event.detail.success) {
      // Clear input
      this.inputTarget.value = "";

      // Reset textarea height if it's a textarea
      if (this.inputTarget.tagName === "TEXTAREA") {
        this.inputTarget.style.height = "auto";
        this.autoResize();
      }

      // Find chat controller and trigger scroll
      const chatController =
        this.application.getControllerForElementAndIdentifier(
          document.querySelector('[data-controller="chat"]'),
          "chat"
        );

      if (chatController) {
        chatController.scrollToBottom();
      }

      // Keep focus on input
      this.inputTarget.focus();
    }
  }
}
